'use strict';

var RomSummaryConfig = function RomSummaryConfig($stateProvider) {
  $stateProvider.state('app.rom-summary', {
    url: '/workflow/rom-summary',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER;ROM'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/rom-summary-panel.html'),
        controller: 'RomSummaryController'
      },
      'mainToolbar': {
        template: require('../templates/rom-summary-toolbar.html'),
        controller: 'RomSummaryToolbarController'
      }
    }
  });
};
RomSummaryConfig.$inject = ['$stateProvider'];
module.exports = RomSummaryConfig;